import Marquee from "react-fast-marquee";

const ITEMS = [
  "Criminal Defence",
  "Anticipatory Bail",
  "Quashing of FIR",
  "NDPS Matters",
  "Criminal Appeals",
  "Section 498A",
  "Bail Matters",
];

export const Ribbon = () => (
  <section className="border-y border-[#262626] bg-[#0A0A0A] py-6" data-testid="marquee-section">
    <Marquee speed={38} gradient gradientColor="#0A0A0A" gradientWidth={120}>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-3xl sm:text-4xl text-[#F7F5F2]/70 px-8">{t}</span>
          <span className="text-[#C8A24B] text-xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
